import script from "./physical.vue?vue&type=script&lang=ts&setup=true"
export * from "./physical.vue?vue&type=script&lang=ts&setup=true"

import "./physical.vue?vue&type=style&index=0&id=92874020&scoped=true&lang=less"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92874020"]])

export default __exports__